@import '../../../../../../constants/spacing.module.less';

.body-wrapper {
  width: 100%;
  padding-left: @space-40;
  gap: @space-24;
}

.row-gap-24 {
  justify-content: flex-start;
  gap: @space-24;
}

.stretch-column {
  flex-grow: 1;
  flex-basis: 0;
}

.disabled {
  background: var(--gray-F1F2F3);
}

.card-wrapper {
  padding-top: 0;
}

.warehouse-loading-indicator {
  height: 24px;
  width: 24px;
}
